/**
 * Emotion cache that runs a Stylis plugin to expand `line-clamp` into -webkit- declarations.
 * Use this cache via CacheProvider so styled components can use standard `line-clamp` without -webkit- in source.
 */
import createCache from '@emotion/cache';
import { prefixer } from 'stylis';
import { lineClampStylisPlugin } from './stylisAutoprefixerPlugin';

const emotionKey = 'esport-app';

export const emotionCache = createCache({
    key: emotionKey,
    stylisPlugins: [prefixer, lineClampStylisPlugin]
});
